module.exports = __webpack_public_path__ + "static/media/education.6df7f107.png";